export function parseFieldKey(fieldKey: string) {
    return fieldKey.split('.');
}
